import { Capacitor, registerPlugin } from '@capacitor/core';

const BatteryOptimization = registerPlugin('BatteryOptimization');

const ASKED_KEY = 'batteryOptExemptionAsked';

// Pide una sola vez (por instalación) la excepción de optimización de batería de
// Android, para que las notificaciones lleguen en segundo plano sin que el usuario
// tenga que ir a Ajustes a desactivar "Pausar actividad de la app si no se usa"
// manualmente — ver BatteryOptimizationPlugin.java para el porqué.
export async function requestBatteryOptimizationExemption() {
  if (Capacitor.getPlatform() !== 'android') return;
  if (localStorage.getItem(ASKED_KEY)) return;
  localStorage.setItem(ASKED_KEY, '1');

  try {
    await BatteryOptimization.requestExemption();
  } catch {
    // Si falla (plugin no disponible, versión vieja de la app), no bloquea nada más.
  }
}
